import {t} from "@lingui/core/macro";

import type {BadgeInfo} from "../badge-translations.ts";

export const generatePatronBadgeStrings = (): Record<string, BadgeInfo> => {
    const badges: Record<string, BadgeInfo> = {};
    // We generate patron badges for this year and next year automatically.
    const nextYear = new Date().getUTCFullYear() + 1;
    for (let year = 2012; year <= nextYear; year++) {
        badges[`patron${year}badge`] = {
            description: t`${year} Patron`,
            // NOTE(jvoll): This is done differently than the one above in an
            // attempt to match the existing translation creating in python.
            // The one above is "%s Patron" and I don't think we can replicate
            // that in JS.
            extendedDescription: t`Support Khan Academy with a donation in ${year}`,
        };
    }
    return badges;
};
